export default __webpack_public_path__ + "static/media/13559 - CPyrc.ae277a47.jpeg";